var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ion:copy-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1642 3.19922H5.23567C4.11137 3.19922 3.19995 4.11064 3.19995 5.23493V13.1635C3.19995 14.2878 4.11137 15.1992 5.23567 15.1992H13.1642C14.2885 15.1992 15.2 14.2878 15.2 13.1635V5.23493C15.2 4.11064 14.2885 3.19922 13.1642 3.19922Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.7822 2.45792L12.8 2.80078C12.7985 2.27081 12.5873 1.76298 12.2126 1.38823C11.8379 1.01349 11.33 0.802289 10.8 0.800781H3.08576C2.4801 0.802571 1.89976 1.04396 1.4715 1.47223C1.04323 1.9005 0.801839 2.48084 0.800049 3.0865V10.8008C0.801557 11.3308 1.01275 11.8386 1.3875 12.2133C1.76225 12.5881 2.27008 12.7993 2.80005 12.8008H2.45719",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyWhite);
export default __webpack_public_path__ + "static/media/copy-white.e87482dfc17320202312943d2f1a2e89.svg";
export { ForwardRef as ReactComponent };